const en = {
  // Navbar
  nav_services: 'Services',
  nav_portfolio: 'Portfolio',
  nav_about: 'About us',
  nav_contact: 'Contact',

  // Hero
  hero_label: 'Consulting · Revenue Growth · Incubation',
  hero_headline_1: 'Strategy, execution and',
  hero_headline_2: 'real growth',
  hero_sub: 'Revenue consulting, operational support and business incubation. For companies that want to scale with rigor.',
  hero_cta_primary: "Let's talk",
  hero_cta_secondary: 'View portfolio',

  // Services
  services_label: 'What we do',
  services_title: 'Three pillars, one system',
  services_desc: 'Each pillar feeds the others. Consulting generates knowledge, knowledge identifies opportunities, opportunities become businesses.',
  s1_title: 'Consulting',
  s1_desc: 'Growth diagnosis and strategy. We work with leadership teams to identify revenue levers, optimize go-to-market and design the commercial engine.',
  s2_title: 'Revenue Growth',
  s2_desc: 'Training and operational support in revenue operations. We don\'t leave a report — we stay until the numbers move.',
  s3_title: 'Incubation',
  s3_desc: 'We identify opportunities, co-create businesses and participate in their development. With skin in the game, from idea to traction.',

  // Portfolio
  portfolio_label: 'Portfolio',
  portfolio_title: 'Who we work with',
  portfolio_sub: 'Companies and projects we support',
  portfolio_cta: 'View project',
  portfolio_note: 'Portfolio under construction. New projects coming soon.',
  tob_sector: 'Industry 4.0 · Waste & Energy',
  tob_desc: 'They transform industrial waste into valuable assets through data technology and automation. Process optimization, waste valorization and integrated data centers on-site.',
  tob_tag: 'Operations & Technology',
  cb_sector: 'Fintech · Bitcoin & Custody',
  cb_desc: 'Collaborative custody and sovereignty service for Bitcoin. A multisig solution that allows maintaining control of funds without relying on banks or centralized custodians.',
  cb_tag: 'Strategy & Finance',

  // About
  about_label: 'About us',
  about_title: 'Who is behind',
  about_role: 'Founder',
  about_bio1: 'Background in technology consulting and business model creation. Focus on revenue growth, commercial strategy and building businesses from scratch. Alice & Bob Capital was born from the conviction that the best consulting is the one that has skin in the game.',
  about_bio2: 'We are not an investment fund. We are not a traditional consultancy. We are a vehicle that accompanies growing companies with strategy, operations and, when it makes sense, direct participation.',

  // Contact
  contact_label: 'Contact',
  contact_title: "Let's talk",
  contact_sub: 'If you want to explore how we can work together, write to us.',
  contact_name: 'Name',
  contact_name_ph: 'Your name',
  contact_email: 'Email',
  contact_email_ph: 'you@email.com',
  contact_message: 'Message',
  contact_message_ph: 'Tell us what you are working on...',
  contact_send: 'Send',
  contact_sending: 'Sending...',
  contact_success: 'Message sent. We will contact you soon.',
  contact_error: 'Something went wrong. Please try again.',

  // Footer
  footer_copy: '© 2026 Alice & Bob Capital',
};

export default en;
